import * as React from 'react';
import { LinkedVideoTile, LinkedVideoType } from './LinkedVideoTile';
import { VideoActions } from './VideoActions';
import { VideoInfo } from '../VideoInfo';
import { VideoTags } from '../VideoTags';
import { Video } from '../../../models';
import './style.css';

export interface VideoDetailsBarProps {
  getVideoUrl: (video: Video) => string;
  loggedIn: boolean;
  nextVideo?: Video | null;
  onFavourite: () => void;
  previousVideo?: Video | null;
  savingFavourite: boolean;
  video: Video;
}

export interface VideoDetailsBarState {
  /* empty*/
}

export class VideoDetailsBar extends React.Component<
  VideoDetailsBarProps,
  VideoDetailsBarState
> {
  render() {
    const {
      getVideoUrl,
      loggedIn,
      nextVideo,
      onFavourite,
      previousVideo,
      savingFavourite,
      video
    } = this.props;
    const { next, previous, description } = video;
    return (
      <div className="video-details-bar">
        <LinkedVideoTile
          getVideoUrl={getVideoUrl}
          video={previousVideo === null ? undefined : previousVideo || previous}
          type={LinkedVideoType.Previous}
        />
        <div className="video-details-content">
          <div className="video-details-content-inner">
            <VideoInfo className="video-details-info" video={video} />
            <VideoTags tags={video.tags} />
            {description && (
              <p
                className="video-description"
                dangerouslySetInnerHTML={{ __html: description }}
              />
            )}
          </div>
          <VideoActions
            getVideoUrl={getVideoUrl}
            loggedIn={loggedIn}
            onFavourite={onFavourite}
            savingFavourite={savingFavourite}
            video={video}
          />
        </div>
        <LinkedVideoTile
          getVideoUrl={getVideoUrl}
          video={nextVideo === null ? undefined : nextVideo || next}
          type={LinkedVideoType.Next}
        />
      </div>
    );
  }
}

export default VideoDetailsBar;



// WEBPACK FOOTER //
// ./src/app/components/Video/VideoDetailsBar/index.tsx